<div class="form-modal modal-theme">
  <h1 mat-dialog-title>{{'PRODUCTSLIST'|translate}}</h1>
  <div mat-dialog-content>
    <div class="form-horizontal modal-dialog-custom">

      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
              (click)="collPnPopup1 = !collPnPopup1">
              <h5 class="panel-title">
                <i class="fas fa-filter"></i>
                <strong>{{'FILTERS'|translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
              </h5>
            </div>
            <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">

              <div class="form-group">
                <div class="col-sm-12">
                  <div class="row no-margin-top">
                    <div class="col-sm-4">
                      <mat-form-field class="full-width">
                        <mat-label>{{'REFERENCE'|translate}}</mat-label>
                        <input type="text" matInput [(ngModel)]="reference">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-8">
                      <mat-form-field class="full-width">
                        <mat-label>{{'NAME'|translate}}</mat-label>
                        <input type="text" matInput [(ngModel)]="name">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group" *ngIf="!hidePurchaseProductsSupplier">
                <div class="col-sm-6">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'SUPPLIER' | translate}}</mat-label>
                    <input matInput [(ngModel)]="supplierName" class="one">
                      <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectSupplier()"></i>
                  </mat-form-field>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-4" *ngIf="categories && categories.length > 0">
                  <mat-form-field class="full-width">
                    <mat-label>{{'CATEGORY'|translate}}</mat-label>
                    <mat-select [(ngModel)]="category">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let category of categories" [value]="category.ID">{{category.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-sm-4" *ngIf="showFilterProductsInPriceList">
                  <mat-checkbox [(ngModel)]="isFilterByPriceList">{{'FILTER_PRODUCTS_PRICE_LIST'|translate}}
                  </mat-checkbox>
                </div>
              </div>

              <div class="form-group" *ngIf="familiesLv1 && familiesLv1.length > 0">
                <div class="col-sm-12">
                  <div class="row no-margin-top">
                    <div class="col-sm-4">
                      <mat-form-field class="full-width">
                        <mat-label>{{'FAMILY'|translate}}</mat-label>
                        <mat-select [(ngModel)]="familyLv1"
                          (selectionChange)="changeFamily(1, $event)">
                          <mat-option></mat-option>
                          <mat-option *ngFor="let family of familiesLv1" [value]="family.ID">{{family.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4" *ngIf="familiesLv2 && familiesLv2.length > 0">
                      <mat-form-field class="full-width">
                        <mat-label>{{'SUBFAMILY'|translate}}</mat-label>
                        <mat-select [(ngModel)]="familyLv2"
                          (selectionChange)="changeFamily(2, $event)">
                          <mat-option></mat-option>
                          <mat-option *ngFor="let family of familiesLv2" [value]="family.ID">{{family.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4" *ngIf="familiesLv3 && familiesLv3.length > 0">
                      <mat-form-field class="full-width">
                        <mat-label>{{'SUBFAMILY'|translate}}</mat-label>
                        <mat-select [(ngModel)]="familyLv3"
                          (selectionChange)="changeFamily(3, $event)">
                          <mat-option></mat-option>
                          <mat-option *ngFor="let family of familiesLv3" [value]="family.ID">{{family.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12 text-right margin-top-10">
                  <button type="button" class="btn btn-primary" (click)="filter()" [title]="'FILTER' | translate">
                    {{'FILTER' | translate}}
                  </button>

                  <button type="button" class="btn btn-default" (click)="clearFilters()"
                    [title]="'BUTTON.CLEAR' | translate">
                    {{'BUTTON.CLEAR' | translate}}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-sm-12 margin-bottom-15 text-center" *ngIf="products && products.length > 0">
          <button type="button" class="btn btn-default" [title]="'PREVIOUS' | translate" (click)="previousPage()"
            [disabled]="page === 0">
            {{'PREVIOUS' | translate}}
          </button>

          <span class="padding-horizontal-15">{{(page + 1) + ' / ' + totalPages}}</span>

          <button type="button" class="btn btn-default" [title]="'NEXT' | translate" (click)="nextPage()"
            [disabled]="(page + 1) === totalPages">
            {{'NEXT' | translate}}
          </button>
        </div>

        <div class="gallery-cont-custom">
          <div class="col-sm-12" *ngIf="!products || products.length === 0">
            <div class="panel panel-default">
              <div class="panel-body no-horizontal-padding">
                <div class="form-group">
                  <div class="col-sm-12 text-center">
                    <h5>{{'NO_RESULTS_WERE_FOUND' | translate}}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-sm-3" *ngFor="let product of products; let i=index">
            <!--<div *ngFor="let quantity of quantities;let j = index">
              *ngIf="quantity.ID == product.ID"-->


            <div class="panel panel-default">
              <div class="panel-body no-horizontal-padding">

                <div class="form-group">
                  <div class="col-sm-12 item">
                    <div class="img">
                      <img class="img-responsive image-center" style="max-width: 200px;"
                        [src]="product.ProductMediaID ? serverUrl + 'Product/GetImage?id=' + product.ProductMediaID + '&productID=' + product.ID + '&width=200&height=200' : './assets/img/no-image.png'"
                        [alt]="product.Name" />
                      <div class="over">
                        <div class="func">
                          <a [href]="product.ProductMediaID ? serverUrl + 'Product/GetImage?id=' + product.ProductMediaID + '&productID=' + product.ID : './assets/img/no-image.png'"
                            class="image-zoom">
                            <i class="fas fa-search"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-12">
                    <h5 class="ellipsis">{{product.Name}}</h5>
                    <h6 class="italic">{{product.PartnerProductCode ? product.IntegrationID + '/' +
                      product.PartnerProductCode : product.IntegrationID}}</h6>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-12">
                    <div class="row no-margin-top">
                      <div class="col-sm-6">
                        <span *ngIf="product.PriceListPrice && product.PriceListPrice > 0"
                          title="{{'SPECIAL_PRICE' | translate}}"><i style="color: #FFCD3C;"
                            class="fas fa-star"></i>&nbsp;</span>
                        <span><strong>{{product.price}}</strong></span>
                      </div>
                      <div class="col-sm-6 text-right">
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="add(product.ID, product.quantity, product.uomCode)"
                          [disabled]="isProductAdded(product.ID) && !allowRepetedProducts"
                          [title]="(isProductAdded(product.ID) && !allowRepetedProducts ? 'ADDED' : 'ADD') | translate">
                          {{( isProductAdded(product.ID) && !allowRepetedProducts ? 'ADDED' : 'ADD') | translate}}
                        </button>
                        <button *ngIf="showAdditionalInfo && product.InfoHtml" type="button" class="btn btn-sm btn-primary"
                          (click)="getAdditionalInfo(product.ID)">
                          + {{'INFO'| translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="row no-margin-top">
                      <div class="col-sm-6">
                        <mat-form-field class="allwidth" style="height: 25px;">
                          <mat-label>{{'QUANTITY' | translate}}</mat-label>
                          <input style="padding-left: 7px;" matInput type="number" [(ngModel)]="product.quantity" OnlyNumber="true" min="1" [disabled]="isProductAdded(product.ID) && !allowRepetedProducts">
                        </mat-form-field>

                      </div>
                      <div class="col-sm-6" *ngIf="showPurchaseProductsUomCode">
                        <mat-form-field class="allwidth">
                          <mat-label>{{ 'UNITY_MEASURE' | translate}}</mat-label>
                          <mat-select [(ngModel)]="product.uomCode">
                            <mat-option value=''></mat-option>
                            <mat-option *ngFor="let unit of detailUnitsG" [value]="unit.Code">{{unit.Name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>
            <!--</div>-->
          </div>

        </div>

        <div class="col-sm-12 margin-bottom-15 text-center" *ngIf="products && products.length > 0">
          <button type="button" class="btn btn-default" [title]="'PREVIOUS' | translate" (click)="previousPage()"
            [disabled]="page === 0">
            {{'PREVIOUS' | translate}}
          </button>

          <span class="padding-horizontal-15">{{(page + 1) + ' / ' + totalPages}}</span>

          <button type="button" class="btn btn-default" [title]="'NEXT' | translate" (click)="nextPage()"
            [disabled]="(page + 1) === totalPages">
            {{'NEXT' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>